module.exports = require("./tk.d.ts");